var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "full-width no-padding-top",
      attrs: { id: "profile-update" }
    },
    [
      _c("div", { staticClass: "container" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("p", [
              _c(
                "button",
                {
                  staticClass: "core-btn",
                  attrs: { disabled: _vm.thinking },
                  on: {
                    click: function($event) {
                      return _vm.clear_planner()
                    }
                  }
                },
                [_vm._v("Clear planner data")]
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "This will clear the automatically generated planner data - this will regenerate on your next visit to the planner"
              )
            ]),
            _vm._v(" "),
            _c("br"),
            _c("br"),
            _vm._v(" "),
            _c("p", [
              _c(
                "button",
                {
                  staticClass: "core-btn",
                  attrs: { disabled: _vm.thinking },
                  on: {
                    click: function($event) {
                      return _vm.clear_caches()
                    }
                  }
                },
                [_vm._v("Clear caches")]
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "This will clear all caches, this can be useful if you're experiencing bugs"
              )
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h2", [_vm._v("Saved data")]),
        _vm._v(" "),
        _c("p", [_vm._v("Here you can manage any locally stored data")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }